const Imagen = ((props) => {
    return (<>
    <div className="w-full px-2 mt-2">
    <div className="flex flex-col items-center">
        <label className="text--sm font-semibold" htmlFor="imagen">Adjuntar Certificado</label>
        <div className="flex flex-col items-center ml-3">
            <input type="file" name="imagen" onChange={(e) => props.setImagen(e.target.files[0])} />
            {props.imagen !== '' ?
                <img src={URL.createObjectURL(props.imagen)} alt="Imagen seleccionada" className="w-1/3 mt-2"/>
            :
            ''
            }
           
        </div>
    </div>
    </div>
    </>)
})

export default Imagen